<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'superAdminDialog.header' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form class="form">
      <div *ngIf="loading" class="loading-spinner">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <section class="app-dialog__section">
          <div class="form-field">
            <label class="field-label">{{ 'superAdminDialog.newAdminEmail' | translate }}</label>
            <mat-form-field appearance="outline">
              <input matInput [formControl]="newAdminEmailControl" type="email" [errorStateMatcher]="createErrorStateMatcher">
              <mat-error *ngIf="newAdminEmailControl.hasError('required')">
                {{ 'fieldRequired' | translate }}
              </mat-error>
              <mat-error *ngIf="newAdminEmailControl.hasError('email')">
                {{ 'emailInvalid' | translate }}
              </mat-error>
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              type="button"
              (click)="createNewAdmin()"
              [disabled]="processing"
              class="inline-action-button"
            >
              {{ (processing ? 'saving' : 'superAdminDialog.createNewAdmin') | translate }}
            </button>
          </div>
        </section>

        <mat-divider class="section-divider"></mat-divider>

        <section class="app-dialog__section">
          <div class="form-field">
            <label class="field-label">{{ 'superAdminDialog.selectAdmin' | translate }}</label>
            <app-searchable-select
              [formControl]="selectedAdminControl"
              [options]="superAdmins"
              [displayWith]="adminLabel"
              [valueWith]="adminValue"
              [errorStateMatcher]="removeErrorStateMatcher"
              [required]="true"
            ></app-searchable-select>
            <mat-error *ngIf="selectedAdminControl.hasError('required') && removeErrorStateMatcher.submitAttempted">
              {{ 'fieldRequired' | translate }}
            </mat-error>
            <button
              mat-raised-button
              color="warn"
              type="button"
              (click)="removeFromAll()"
              [disabled]="processing"
              class="inline-action-button"
            >
              {{ (processing ? 'removing' : 'superAdminDialog.removeFromAll') | translate }}
            </button>
          </div>
        </section>
      </ng-container>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
  </footer>
</div>
